// @ts-nocheck
import axios from "axios";
import cookie from "./cookie";

const ONE_DAY = 24 * 60 * 60 * 1000;

function setClerkAuthToken(token) {
  const expires = new Date(Date.now() + ONE_DAY);

  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  cookie.set({
    name: "clerk_token",
    value: token,
    expires
  });
}


function getClerkAuthToken() {
  const expires = new Date(Date.now() + ONE_DAY);

  return cookie.get("clerk_token");
}

function deleteClerkAuthToken() {
  cookie.delete("clerk_admin_token");
}

function setClerkUserToken(user) {
  const expires = new Date(Date.now() + ONE_DAY + 1000);

  cookie.set({
    name: "clerk_user_token",
    value: user,
    expires
  });
}

function getClerkUserToken() {
  const str = cookie.get("clerk_user_token");
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
}

function setAdminCookie(admin) {
  const expires = new Date(Date.now() + ONE_DAY + 1000);

  cookie.set({
    name: "clerk_admin_token",
    value: admin,
    expires
  });
}

function getAdminCookie(cb = null) {
  const str = cookie.get("clerk_admin_token");
  try {
    if (!str) {
      cb && cb();
      return {};
    }
    return JSON.parse(str);
    // return JSON.parse(str) || {};
  } catch (e) {
    return {};
  }
}

export {
  deleteClerkAuthToken,
  getClerkAuthToken,
  getClerkUserToken,
  setClerkAuthToken,
  setClerkUserToken,
  setAdminCookie,
  getAdminCookie
}

